import { DatePicker, Flex, Table } from 'antd'
import { useState } from 'react'
import { useParams } from 'react-router-dom'

import { usePersonsServiceGetListPersonInstitutionsHistoryEndpoint } from 'src/api/queries'
import { PersonInstitutionsHistorySortBy } from 'src/api/requests'
import { Select, Text } from 'src/components'
import {
  useTransferColumns,
  useTransferConfig
} from 'src/features/persons/components'
import { useStyles } from 'src/features/persons/styles'
import { useTablePagination } from 'src/hooks'
import { dayMonthYearBackSlash } from 'src/libs'
import { useLocales } from 'src/locales'
import {
  getOrderingDirection,
  normalizeOrdering,
  resetPagination
} from 'src/utils'

export const PersonTransfersPage = () => {
  const { t } = useLocales()
  const { styles } = useStyles()
  const { id: personId } = useParams()

  const pagination = useTablePagination()

  const { options } = useTransferConfig()
  const { columns } = useTransferColumns()

  const [startDate, setStartDate] = useState<string[]>([])
  const [endDate, setEndDate] = useState<string[]>([])
  const [ordering, setOrdering] = useState('')

  const queryParams = {
    pageNumber: pagination.current,
    pageSize: pagination.pageSize,
    ...(ordering && {
      sortBy: normalizeOrdering(ordering) as PersonInstitutionsHistorySortBy,
      sortDirection: getOrderingDirection(ordering)
    }),
    ...(startDate?.[0] &&
      startDate?.[1] && {
        startDateFrom: startDate?.[0],
        startDateTo: startDate?.[1]
      }),
    ...(endDate?.[0] &&
      endDate?.[1] && {
        endDateFrom: endDate?.[0],
        endDateTo: endDate?.[1]
      }),
    personId: String(personId)
  }

  const { data, isLoading } =
    usePersonsServiceGetListPersonInstitutionsHistoryEndpoint(queryParams)

  const onSetStartDate = (val: string[]) => {
    setStartDate(val)
    resetPagination(pagination)
  }

  const onSetEndDate = (val: string[]) => {
    setEndDate(val)
    resetPagination(pagination)
  }

  const onOrderChange = (val: string) => {
    setOrdering(val)
    resetPagination(pagination)
  }

  return (
    <Flex vertical gap={16}>
      <Flex justify="space-between" wrap="wrap" gap={8}>
        <Text className={styles.text}>
          {t('persons.person_transfer-history')}
        </Text>

        <Flex gap={8}>
          <DatePicker.RangePicker
            format={[dayMonthYearBackSlash, dayMonthYearBackSlash]}
            className="full-width"
            placeholder={[
              t('transfer.start_date_from'),
              t('transfer.start_date_to')
            ]}
            onChange={(_, val) => onSetStartDate(val)}
          />

          <DatePicker.RangePicker
            format={dayMonthYearBackSlash}
            className="full-width"
            placeholder={[
              t('transfer.end_date_from'),
              t('transfer.end_date_to')
            ]}
            onChange={(_, val) => onSetEndDate(val)}
          />

          <Select onSelect={(val) => onOrderChange(val)} options={options} />
        </Flex>
      </Flex>

      <Table
        rowKey="id"
        loading={isLoading}
        columns={columns}
        dataSource={data?.data}
        pagination={{ ...pagination, total: data?.totalCount }}
        scroll={{ x: 'max-content' }}
      />
    </Flex>
  )
}
